import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'


export enum ClassType {
  klasses = 'klasses',
  DayCares = 'day_cares',
  Camp = 'camp',
}

export type ClassTypes = Array<ItemType>

class ClassTypeFilterDataBox extends DataBox<ClassTypes> { }

export const defaultClassType: ClassTypes = []
export const classTypeFilter = createDataBox('classTypeFilter', defaultClassType, ClassTypeFilterDataBox)

export const defaultClassTypeData = () => {
  return [{
    id: ClassType.klasses,
    title: 'Классы',
  }, {
    id: ClassType.DayCares,
    title: 'ГПД',
  }, {
    id: ClassType.Camp,
    title: 'Лагерь',
  }
  ]
}

classTypeFilter.updateData(defaultClassTypeData)
classTypeFilter.setStatusReady()

export const defaultClassTypeSelection: Array<string> = []
export const classTypeFilterSelection = createDataBoxDefault<Array<string>>('classTypeSelection', defaultClassTypeSelection)
